import {
  POST_DETAILS,
  POST_DETAILS_FAILED,
  POST_DETAILS_FINISHED,
  SEND_VERIFICATION_CODE,
  SEND_VERIFICATION_CODE_FAILED,
  SEND_VERIFICATION_CODE_FINISHED,
  SUBMIT_DETAILS,
  VERIFY_CODE,
  VERIFY_CODE_FAILED,
  VERIFY_CODE_FINISHED,
  LOAD_PARTIAL_REPORT_FINISHED,
  LOAD_PARTIAL_REPORT_FAILED,
  LOAD_REPORT_THRESHOLD,
  LOAD_REPORT_THRESHOLD_FINISHED,
  LOAD_REPORT_THRESHOLD_FAILED
} from 'store/actions/leadgenAction'
import { PURGE } from 'redux-persist'

const DEFAULT_STATUS = {
  isError: false,
  isLoading: false,
  msg: ''
}

const INITIAL_STATE = {
  details: {},
  otpStatus: null,
  reportCode: null,
  status: DEFAULT_STATUS,
  partialReport: {
    data: {},
    status: {
      isError: false,
      isLoading: true,
      msg: ''
    }
  },
  reportThreshold: {
    data: {},
    status: {
      isError: false,
      isLoading: true,
      msg: ''
    }
  }
}

function getMobileNumber(isError, state, mobileNumber) {
  return isError ? state.details.mobileNumber : mobileNumber
}

function getResendSmsMessage(isResend) {
  return isResend ? 'Verification code re-sent, Enter above to verify' : DEFAULT_STATUS.msg
}

export default function leadgenReducer(
  state = INITIAL_STATE, { type, payload } = {}
) {
  switch (type) {
    case SUBMIT_DETAILS:
      return {
        ...state,
        details: payload
      }
    case POST_DETAILS:
      return {
        ...state,
        status: {
          ...state.status,
          isError: false,
          isLoading: true
        }
      }
    case SEND_VERIFICATION_CODE:
      return {
        ...state,
        status: {
          ...state.status,
          isError: false,
          isLoading: true,
          msg: 'Sending code, Please wait a moment!'
        }
      }
    case VERIFY_CODE:
      return {
        ...state,
        status: {
          ...state.status,
          isError: false,
          isLoading: true,
          msg: 'Verifying, Please wait a moment!'
        }
      }
    case POST_DETAILS_FINISHED:
    case VERIFY_CODE_FINISHED: {
      const { errors, reportCode } = payload
      const isError = !!errors && errors.length > 0

      return {
        ...state,
        reportCode: reportCode || INITIAL_STATE.reportCode,
        status: {
          isError: isError,
          isLoading: false,
          msg: isError ? 'Invalid Code, Verification Failed!' : 'Verification Successful!'
        }
      }
    }
    case SEND_VERIFICATION_CODE_FINISHED: {
      const { errors, isResend, mobileNumber, status } = payload
      const isError = !!errors && errors.length > 0

      return {
        ...state,
        otpStatus: status || state.otpStatus,
        details: {
          ...state.details,
          mobileNumber: !mobileNumber ? state.details.mobileNumber : getMobileNumber(isError, state, mobileNumber)
        },
        status: {
          isError: isError,
          isLoading: false,
          msg: isError
            ? 'Specified mobile number is Invalid'
            : getResendSmsMessage(isResend)
        }
      }
    }
    case POST_DETAILS_FAILED: {
      const { code } = payload
      const isLimitedError = code === 403

      return {
        ...state,
        status: {
          isError: true,
          isLoading: false,
          msg: DEFAULT_STATUS.msg,
          isLimitedError: isLimitedError
        }
      }
    }
    case SEND_VERIFICATION_CODE_FAILED: {
      const { code } = payload
      const isLimitedError = code === 403

      return {
        ...state,
        status: {
          isError: true,
          isLoading: false,
          msg: 'Send Verification Failed!',
          isLimitedError: isLimitedError
        }
      }
    }
    case VERIFY_CODE_FAILED:
      return {
        ...state,
        status: {
          isError: true,
          isLoading: false,
          msg: 'Invalid Code, Verification Failed!'
        }
      }
    case LOAD_PARTIAL_REPORT_FINISHED: {
      const { errors } = payload
      const isError = errors.length > 0
      return {
        ...state,
        partialReport: {
          data: payload,
          status: {
            isError,
            isLoading: false,
            msg: isError ? errors : ''
          }
        }
      }
    }
    case LOAD_PARTIAL_REPORT_FAILED: {
      return {
        ...state,
        partialReport: {
          data: {},
          status: {
            isError: true,
            isLoading: false,
            msg: payload
          }
        }
      }
    }
    case LOAD_REPORT_THRESHOLD:
      return {
        ...state,
        reportThreshold: {
          ...state.reportThreshold
        }
      }
    case LOAD_REPORT_THRESHOLD_FINISHED: {
      const { errors } = payload
      const isError = errors?.length > 0
      return {
        ...state,
        reportThreshold: {
          data: payload,
          status: {
            isError,
            isLoading: false,
            msg: isError ? errors : ''
          }
        }
      }
    }
    case LOAD_REPORT_THRESHOLD_FAILED: {
      return {
        ...state,
        reportThreshold: {
          data: {},
          status: {
            isError: true,
            isLoading: false,
            msg: payload
          }
        }
      }
    }
    case PURGE:
      return INITIAL_STATE
    default:
      return state
  }
}
